import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ColumnTypeIconModule } from '@y42/column-type';
import { FormatValueConversionModule } from '@y42/core/format-value-conversion';
import { IntercomTargetModule } from '@y42/intercom';
import { HeaderRendererComponent } from './header-renderer.component';

@NgModule({
  declarations: [HeaderRendererComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    FontAwesomeModule,
    ColumnTypeIconModule,
    IntercomTargetModule,
    FormatValueConversionModule,
  ],
  exports: [HeaderRendererComponent],
})
export class HeaderRendererModule {}
